import { Setting } from '@120wateraudit/envirio-components/dist/models'
import CrudActions, { ICrudActions } from 'src/actions/helpers/CrudActions'

const actions: ICrudActions = CrudActions<Setting>({
  entityName: 'setting',
  collectionName: 'settings'
})

export default actions
